import { __decorate, __metadata, __read, __spread } from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
/**
 * Used to inject a new instance of a dependency, without regard for existing
 * instances in the container. Instances can optionally be registered in the container
 * under a different key by supplying a key using the `as` method.
 */
var NewInstanceResolver = /** @class */ (function () {
    /**
     * Creates an instance of the NewInstance class.
     * @param key The key to resolve/instantiate.
     * @param dynamicDependencies An optional list of dynamic dependencies.
     */
    function NewInstanceResolver(key) {
        var dynamicDependencies = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            dynamicDependencies[_i - 1] = arguments[_i];
        }
        this._key = key;
        this._asKey = key;
        this._dynamicDependencies = dynamicDependencies;
    }
    NewInstanceResolver_1 = NewInstanceResolver;
    /**
     * Creates an NewInstance Resolver for the supplied key.
     * @param key The key to resolve/instantiate.
     * @param dynamicDependencies An optional list of dynamic dependencies.
     * @return Returns an instance of NewInstance for the key.
     */
    NewInstanceResolver.of = function (key) {
        var dynamicDependencies = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            dynamicDependencies[_i - 1] = arguments[_i];
        }
        return new (NewInstanceResolver_1.bind.apply(NewInstanceResolver_1, __spread([void 0, key], dynamicDependencies)))();
    };
    /**
     * Called by the container to instantiate the dependency and potentially register
     * as another key if the `as` method was used.
     * @param container The container to resolve the parent from.
     * @return Returns the matching instance from the parent container
     */
    NewInstanceResolver.prototype.get = function (container, key) {
        var dynamicDependencies = this._dynamicDependencies.length > 0
            ? this._dynamicDependencies.map(function (dependency) {
                return dependency['protocol:aurelia:resolver']
                    ? dependency.get(container)
                    : container.get(dependency);
            })
            : undefined;
        var _key = this._key;
        var resolver = container.getResolver(_key);
        if (resolver && resolver.strategy === Strategy.Function) {
            _key = resolver.state;
        }
        var instance = container.invoke(_key, dynamicDependencies);
        container.registerInstance(this._asKey, instance);
        return instance;
    };
    /**
     * Instructs the NewInstance resolver to register the resolved instance using the supplied key.
     * @param key The key to register the instance with.
     * @return Returns the NewInstance resolver.
     */
    NewInstanceResolver.prototype.as = function (key) {
        this._asKey = key;
        return this;
    };
    var NewInstanceResolver_1;
    NewInstanceResolver = NewInstanceResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object, Object])
    ], NewInstanceResolver);
    return NewInstanceResolver;
}());
export { NewInstanceResolver };
//# sourceMappingURL=data:application/json;base64,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